import { IFavoriteButtonWidget } from '#/types/widgets';
import { getStyleDeclaration } from './get-style-declaration';
import {
  activeState,
  focusState,
  hoverState,
  mobileActiveState,
  parentFocusState,
  relativeBorderRadius,
  widgetSelector,
} from './helpers';
import { getWidgetGeometry } from '../recalculate-positions';

export function favoriteButtonWidget(widgetDescription: IFavoriteButtonWidget) {
  const {
    placements = [],
    width,
    height,
    iconSize,
    borderRadius,
  } = widgetDescription;
  const selector = widgetSelector(widgetDescription);
  const rules = [
    ...placements.map(getStyleDeclaration.positions(selector)),
    ...placements.map(getStyleDeclaration.size(selector)),
  ];

  rules.push([
    selector,
    [['border-radius', relativeBorderRadius(borderRadius, widgetDescription)]],
  ]);

  rules.push([
    hoverState(selector),
    [['background-color', 'rgba(255, 255, 255, 0.40)']],
  ]);

  rules.push([
    activeState(selector),
    [['background-color', 'rgba(255, 255, 255, 0.20)']],
  ]);

  rules.push([
    mobileActiveState(selector),
    [
      ['background-color', 'rgba(255, 255, 255, 0.20)'],
      ['opacity', '0.5'],
    ],
  ]);

  rules.push([
    parentFocusState(selector, '[data-role="icon"] path'),
    [['fill', '#000']],
  ]);

  rules.push([focusState(selector), [['background-color', '#fff']]]);

  const iconGeometry = getWidgetGeometry(
    { width: iconSize, height: iconSize },
    width,
    height,
  );

  rules.push([
    `${selector} svg`,
    [
      ['height', iconGeometry.relativeSize.height],
      ['width', iconGeometry.relativeSize.width],
    ],
  ]);

  return rules;
}
